import { errName, errStatus } from '../js';

export const cFetch = function f(input, opts) {
  const fetchPromise = fetch(input, opts);
  const timeoutPromise = new Promise((resolve, reject) => {
    const timeout = opts.timeout || window.FETCH_TIMEOUT || 30000;
    setTimeout(() => {
      /* eslint-disable prefer-promise-reject-errors */
      reject({
        name: errName.FETCH,
        status: errStatus.TIMEOUT,
      });
      /* eslint-enable prefer-promise-reject-errors */
    }, timeout);
  });
  const handleResponse = (response) => {
    const contentType = response.headers.get('content-type');
    const handlers = {
      JSONResponseHandler(res) {
        return res.json().then((json) => {
          if (res.ok) {
            return Promise.resolve({
              status: res.status,
              statusText: res.statusText,
              payload: json,
            });
          }
          /* eslint-disable prefer-promise-reject-errors */
          return Promise.reject({
            name: errName.FETCH,
            status: res.status,
            statusText: res.statusText,
            payload: json,
          });
          /* eslint-enable prefer-promise-reject-errors */
        });
      },
      textResponseHandler(res) {
        return res.text().then((text) => {
          if (res.ok) {
            return Promise.resolve({
              status: res.status,
              statusText: res.statusText,
              payload: text,
            });
          }
          /* eslint-disable prefer-promise-reject-errors */
          return Promise.reject(
            {

              name: errName.FETCH,
              status: res.status,
              statusText: res.statusText,
              payload: text,
            },
          );
          /* eslint-enable prefer-promise-reject-errors */
        });
      },
      nullResponseHandler(res) {
        return Promise.resolve({
          status: res.status,
          statusText: res.statusText,
          payload: null,
        });
      },
    };
    if (contentType === null) {
      return handlers.nullResponseHandler(response);
    }
    if (contentType.indexOf('application/json') >= 0) {
      return handlers.JSONResponseHandler(response);
    }
    if (contentType.indexOf('text/plain') >= 0) {
      return handlers.textResponseHandler(response);
    }
    /* eslint-disable prefer-promise-reject-errors */
    return Promise.reject({
      name: errName.FETCH,
      status: response.status,
      statusText: response.statusText,
      payload: `Sorry, content-type ${contentType} not supported`,
    });
    /* eslint-enable prefer-promise-reject-errors */
  };
  return Promise.race([fetchPromise, timeoutPromise]).then(handleResponse);
};

export const CB_STATUS = {
  SUCCESS: 'SUCCESS',
  EXIST: 'EXIST',
  FORBID: 'FORBID',
  INVALID: 'INVALID',
  UNAUTH: 'UNAUTH',
  UNREACH: 'UNREACH',
  TIMEOUT: 'TIMEOUT',
  OTHER: 'OTHER',
  MAXLIMITDevice: 'MAXLIMITDevice',
  MAXLIMITAcc: 'MAXLIMITAcc',
  VERIFYFAIL: 'VERIFYFAIL',
  RESETLIMIT: 'RESETLIMIT',
  ACCOUNTLOCKED: 'ACCOUNTLOCKED',
};
